"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _r10SourceLibrary = require("r10-source-library");
var _SuccessMessage = _interopRequireDefault(require("./SuccessMessage"));
var _RatingStars = _interopRequireDefault(require("./RatingStars"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _useRecommendationHandsets = require("../../hooks/recommendation/useRecommendationHandsets");
var _recommendationSelectors = require("../../store/recommendation/recommendationSelectors");
var _useAppSelector = require("../../hooks/useAppSelector");
var _useAppDispatch = require("../../hooks/useAppDispatch");
var _useRecommendationBusinessSolutions = require("../../hooks/recommendation/useRecommendationBusinessSolutions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const StyledGridColumn = (0, _styledComponents.default)(_r10SourceLibrary.GridColumn)`
  padding: 0 !important;
`;
const StarsRatingFeedback = _ref => {
  let {
    starsPadding,
    starsScale
  } = _ref;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const {
    selectedHandset
  } = (0, _useRecommendationHandsets.useRecommendationHandsets)();
  const {
    selectedBusinessSolution
  } = (0, _useRecommendationBusinessSolutions.useRecommendationBusinessSolutions)();
  const selectedProduct = selectedHandset || selectedBusinessSolution;
  const ratingIdentifier = `${selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.productId}__${selectedProduct === null || selectedProduct === void 0 ? void 0 : selectedProduct.tier}`;
  const ratings = (0, _useAppSelector.useAppSelector)(_recommendationSelectors.selectRating);
  const currentRatingValue = ratings[ratingIdentifier];
  const handleRatingClick = rating => {
    const ratingData = {
      productId: ratingIdentifier,
      rating
    };
    dispatch((0, _recommendationActions.setRating)(ratingData));
    dispatch((0, _recommendationActions.saveRating)());
  };
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3
    }
  }, /*#__PURE__*/_react.default.createElement(StyledGridColumn, null, currentRatingValue ? /*#__PURE__*/_react.default.createElement(_SuccessMessage.default, {
    "data-testid": "feedback-success-message"
  }) : /*#__PURE__*/_react.default.createElement(_RatingStars.default, {
    handleRatingClick: handleRatingClick,
    starsPadding: starsPadding,
    starsScale: starsScale
  })));
};
var _default = StarsRatingFeedback;
exports.default = _default;